module.exports = __webpack_public_path__ + "static/media/croma-priveleges.acbc42bc.png";